// Material Dashboard 2 React layouts
import React from 'react'
import Icon from "@mui/material/Icon";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Inventory from "./layouts/inventory/index"
import LegacySignUp from "./layouts/authentication/sign-up/LegacySignUp";
import ForgetPassword from "./layouts/authentication/forget-password"
// @mui icons

import Outbounds from "./layouts/outbounds";
import ReportsPage from "./layouts/reports";
import BillingPage from "./layouts/myBilling";
import CustomerOutlet from "./layouts/customer/CustomerOutlet";
import OwnerCustomer from "./layouts/customer/owner_customer/OwnerCustomer";
import OwnerCargo from "./layouts/customer/owner_cargo/OwnerCargo";
import Integration from "./layouts/integration";
import SystemOutlet from "./layouts/system/SystemOutlet";
import OauthCredential from "./layouts/system/oauthCredential";


const Dashboard = React.lazy(() => import('./layouts/dashboard/index'));
const CollectionRequisitionSearch  = React.lazy(()=>import("./layouts/myBilling/CollectionRequisition"))
const InvoiceManagementPage  = React.lazy(()=>import("./layouts/myBilling/invoice/InvoiceManagement"))
const OwnerCashManagement  = React.lazy(()=>import("./layouts/myBilling/ownerCashManagement/OwnerCashManagement"))
const OtherFeeRequisitionPage  = React.lazy(()=>import("./layouts/myBilling/otherFee/OtherFeeRequisition"))
const MappingPage = React.lazy(() => import("./layouts/inventory/mapping"))
const Products = React.lazy(()=> import("./layouts/inventory/products"))
const InventoryStock = React.lazy(()=> import("./layouts/inventory/stockCheck"))
const KitManagement = React.lazy(()=> import("./layouts/inventory/kit"))
const PackagingPage = React.lazy(()=> import("./layouts/inventory/packaging/PackagingHome"))
const CustomerPage = React.lazy(()=> import("./layouts/customer"))
const InboundsPage = React.lazy(()=> import("./layouts/inbounds"))
const ReturnPage = React.lazy(()=> import("./layouts/returns"))
const WholesalePage = React.lazy(()=> import("./layouts/outbounds/wholesale"))
const EcommercePage = React.lazy(() => import("./layouts/outbounds/ecommerce"))
const InventoryReportPage = React.lazy(()=>import("./layouts/reports/inventory"))
const FulfillmentReportPage = React.lazy(()=> import("./layouts/reports/fulfillment"))
const SalesReportPage = React.lazy(() => import("./layouts/reports/sales"))
const NonCanadianShippingFeePage =  React.lazy(() => import("./layouts/reports/adminReports/nonCanada/NonCanadaShippingFee"))
const OnlineShopPage = React.lazy(() => import("./layouts/integration/onlineShop"))
const StorageFeeManagementPage  = React.lazy(()=>import("./layouts/myBilling/storageFee/StorageFeeManagement"))
const RevenueCalculatorPage  = React.lazy(()=>import("./layouts/myBilling/revenueCalculator/RevenueCalculator"))
const SystemSettings = React.lazy(()=>import("./layouts/system/SystemSettings"));
const SubCustomer = React.lazy(()=>import("./layouts/system/subcustomer"));
const StorageFeeAuthority = React.lazy(()=>import("./layouts/system/storageFeeAuthority/StorageFeeAuthority"));
const DiscountManagement = React.lazy(()=>import("./layouts/system/discountManagement/DiscountManagement"));
const WarehouseSettings = React.lazy(()=>import("./layouts/system/WarehouseSettings"));
const Developer = React.lazy(()=>import("./layouts/system/Developer"));
const NotificationManagement = React.lazy(()=>import("./layouts/system/notificationManagement/NotificationManagement"));
const adminRoutes = [
    {
        type: "collapse",
        name: "Dashboard",
        chineseName:"数据看板",
        key: "dashboard",
        icon: <Icon fontSize="small">dashboard</Icon>,
        route: "/dashboard",
        isAuth: true,
        component: <Dashboard/>,
    },
    {
        type: "collapse",
        name: "Inventory",
        chineseName:"库存管理",
        key: "inventory",
        icon: <Icon fontSize="small">inventory</Icon>,
        route: "/inventory",
        component: <Inventory/>,
        isAuth: true,
        children: [
            {
                type: "collapse",
                name: "Inventory Stock",
                chineseName:"库存查询",
                key: "inventory_stock",
                icon: <Icon fontSize="small">inventory_2</Icon>,
                route: "/inventory_stock",
                component: <InventoryStock/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Product",
                chineseName:"商品入驻",
                key: "products",
                icon: <Icon fontSize="small">work</Icon>,
                route: "/products",
                component: <Products/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Kit Management",
                chineseName:"套餐管理",
                key: "kit_management",
                icon: <Icon fontSize="small">table_chart</Icon>,
                route: "/kit_management",
                component: <KitManagement/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Packaging",
                chineseName:"包装",
                key: "packaging",
                icon: <Icon fontSize="small">table_view</Icon>,
                route: "/packaging",
                component: <PackagingPage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "SKU Mapping",
                chineseName:"商品映射",
                key: "sku_mapping",
                icon: <Icon fontSize="small">device_hub</Icon>,
                route: "/sku_mapping",
                component: <MappingPage/>,
                isAuth: true,
            },
        ]
    },
    {
        type: "collapse",
        name: "Customer",
        chineseName:"客户管理",
        key: "customer",
        icon: <Icon fontSize="small">person</Icon>,
        route: "/customer",
        component: <CustomerOutlet/>,
        isAuth: true,
        children: [
            {
                type: "collapse",
                name: "Address Book",
                chineseName:"客户地址簿",
                key: "owner_customer",
                icon: <Icon fontSize="small">groups</Icon>,
                route: "/owner_customer",
                component: <OwnerCustomer/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Cargo Owner",
                chineseName:"货主",
                key: "cargo_owner",
                icon: <Icon fontSize="small">supervisor_account</Icon>,
                route: "/cargo_owner",
                component: <OwnerCargo/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Address Books",
                chineseName:"客户地址簿",
                key: "owner_customers",
                icon: <Icon fontSize="small">person</Icon>,
                route: "/owner_customers",
                component: <CustomerPage/>,
                isAuth: true,
            },
        ]
    },
    {
        type: "collapse",
        name: "Inbounds",
        chineseName:"入库",
        key: "inbounds",
        icon: <Icon fontSize="small">input</Icon>,
        route: "/inbounds",
        component: <InboundsPage/>,
        isAuth: true,
    },

    {
        type: "collapse",
        name: "Outbounds",
        chineseName:"出库",
        key: "outbounds",
        icon: <Icon fontSize="small">output</Icon>,
        route: "/outbounds",
        component: <Outbounds/>,
        isAuth: true,
        children: [
            {
                type: "collapse",
                name: "Wholesale",
                chineseName:"仓库订单",
                key: "wholesale",
                icon: <Icon fontSize="small">warehouse</Icon>,
                route: "/wholesale",
                component: <WholesalePage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "E-commerce",
                chineseName:"电商订单",
                key: "e-commerce",
                icon: <Icon fontSize="small">shopping_cart</Icon>,
                route: "/e-commerce",
                component: <EcommercePage/>,
                isAuth: true,
            }
        ]
    },
    {
        type: "collapse",
        name: "Returns",
        key: "returns",
        chineseName: '退货订单',
        icon: <Icon fontSize="small">archive</Icon>,
        route: "/returns",
        component: <ReturnPage/>,
        isAuth: true,
    },
    {
        type: "collapse",
        name: "Integration",
        chineseName:"集成",
        key: "integration",
        icon: <Icon fontSize="small">call_merge</Icon>,
        route: "/integration",
        component: <Integration/>,
        isAuth: true,
        children: [

            {
                type: "collapse",
                name: "Online Shop",
                chineseName: "在线商店",
                key: "online_shop",
                icon: <Icon fontSize="small">store</Icon>,
                route: "/online_shop",
                component: <OnlineShopPage/>,
                isAuth: true,
            }
        ]
    },
    {
        type: "collapse",
        name: "Report",
        chineseName: "报表",
        key: "report",
        icon: <Icon fontSize="small">show_chart</Icon>,
        route: "/report",
        component: <ReportsPage/>,
        isAuth: true,
        children: [
            {
                type: "collapse",
                name: "Non Canada Shipping",
                chineseName: "非加拿大发货报表",
                key: "non_canada",
                icon: <Icon fontSize="small">assessment</Icon>,
                route: "/non_canada",
                component: <NonCanadianShippingFeePage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Inventory Report",
                chineseName: "库存报表",
                key: "inventory_reports",
                icon: <Icon fontSize="small">inventory</Icon>,
                route: "/inventory_reports",
                component: <InventoryReportPage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Fulfillment Report",
                chineseName: "履约报表",
                key: "fulfillment_reports",
                icon: <Icon fontSize="small">fact_check</Icon>,
                route: "/fulfillment_reports",
                component: <FulfillmentReportPage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Sales Report",
                chineseName: "销售报表",
                key: "sales_reports",
                icon: <Icon fontSize="small">monetization_on</Icon>,
                route: "/sales_reports",
                component: <SalesReportPage/>,
                isAuth: true,
            }
        ]
    },
    {
        type: "collapse",
        name: "Billing",
        chineseName: "结算",
        key: "billing",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/billing",
        isAuth: true,
        component: <BillingPage/>,
        children: [
            {
                type: "collapse",
                name: "Other Fee Requisition",
                chineseName: "其他费用申请",
                key: "other_fee",
                icon: <Icon fontSize="small">payments</Icon>,
                route: "/other_fee",
                component: <OtherFeeRequisitionPage/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Collection Requisition",
                chineseName: "收款申请",
                key: "collection_requisition",
                icon: <Icon fontSize="small">inventory</Icon>,
                route: "/collection_requisition",
                component: <CollectionRequisitionSearch/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Invoice Management",
                chineseName: "发票管理",
                key: "invoice_management",
                icon: <Icon fontSize="small">receipt_outlined</Icon>,
                route: "/invoice_management",
                component: <InvoiceManagementPage/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Storage Fee Management",
                chineseName: "储存费管理",
                key: "storage_fee",
                icon: <Icon fontSize="small">event_note</Icon>,
                route: "/storage_fee",
                component: <StorageFeeManagementPage/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Owner Cash Management",
                chineseName: "客户现金管理",
                key: "owner_cash",
                icon: <Icon fontSize="small">receipt_outlined</Icon>,
                route: "/owner_cash",
                component: <OwnerCashManagement/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Revenue Calculator",
                key: "revenue_calculator",
                chineseName: "营收计算器",
                icon: <Icon fontSize="small">scale</Icon>,
                route: "/revenue_calculator",
                component: <RevenueCalculatorPage/>,
                isAuth: true,

            },
        ]
    },
    {
        type: "collapse",
        name: "Account",
        chineseName: "个人账户",
        key: "account",
        icon: <Icon fontSize="small">manage_accounts</Icon>,
        route: "/account",
        isAuth: true,
        component: <Profile/>,
    },
    {
        type: "collapse",
        name: "System",
        chineseName: "系统设置",
        key: "system",
        icon: <Icon fontSize="small">settings</Icon>,
        route: "/system",
        component: <SystemOutlet/>,
        isAuth: true,
        children: [

            {
                type: "collapse",
                name: "Price Setting",
                chineseName: "价格设置",
                key: "price_setting",
                icon: <Icon fontSize="small">candlestick_chart</Icon>,
                route: "/price_setting",
                isAuth: true,
                component: <SystemSettings/>,
            },

            {
                type: "collapse",
                name: "Warehouse",
                chineseName: "仓库设置",
                key: "warehouse",
                icon: <Icon fontSize="small">warehouse</Icon>,
                route: "/warehouse",
                isAuth: true,
                component: <WarehouseSettings/>,
            },
            {
                type: "collapse",
                name: "Users Management",
                key: "users_management",
                chineseName: "用户管理",
                icon: <Icon fontSize="small">account_tree</Icon>,
                route: "/users_management",
                isAuth: true,
                // component: <SubCustomer/>,
                component: <SubCustomer/>,
            },
            {
                type: "collapse",
                name: "Notification Management",
                key: "notification_management",
                chineseName: "通知管理",
                icon: <Icon fontSize="small">notifications</Icon>,
                route: "/notification_management",
                isAuth: true,
                component: <NotificationManagement/>,
            },
            {
                type: "collapse",
                name: "Storage Fee Filter",
                chineseName: "储存费筛选",
                key: "storage_fee_filter",
                icon: <Icon fontSize="small">event_note</Icon>,
                route: "/storage_fee_filter",
                component: <StorageFeeAuthority/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Discount Management",
                chineseName: "折扣管理",
                key: "discount_management",
                icon: <Icon fontSize="small">discount</Icon>,
                route: "/discount_management",
                component: <DiscountManagement/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Developer",
                chineseName: "认证授权",
                key: "developer",
                icon: <Icon fontSize="small">code</Icon>,
                route: "/developer",
                component: <Developer/>,
                isAuth: true,

            },
        ]
    },
    {
        type: "collapse",
        name: "Sign In",
        chineseName: "登录",
        key: "sign-in",
        isAuth: false,
        icon: <Icon fontSize="small">login</Icon>,
        route: "/authentication/sign-in",
        component: <SignIn/>,
    },
    {
        type: "collapse",
        name: "Sign Up",
        chineseName: "货主注册",
        key: "sign-up",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/authentication/sign-up",
        isAuth: false,
        component: <SignUp/>,
    },
    {
        type: "collapse",
        name: "Legacy Sign Up",
        chineseName: "老货主注册",
        key: "legacy-sign-up",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/authentication/legacy-sign-up",
        isAuth: false,
        component: <LegacySignUp/>,
    },

    {
        type: "collapse",
        name: "Forgot Password",
        chineseName: "找回密码",
        key: "forget-password",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/authentication/forget_password",
        isAuth: false,
        component: <ForgetPassword/>,
    },

];

export default adminRoutes;
